import type { OrganizationCalendar, RecurringException } from "@opus-dt/shared-types";
import { toast } from "@/components/ui/notify";
import { RecurrenceSection } from "./RecurrenceSection";
import { useUpdateOrganizationCalendar } from "./hooks";

interface Props {
  calendar: OrganizationCalendar | null;
  canEdit: boolean;
}

// As regras recorrentes DA FÁBRICA.
// Casca fina sobre `<RecurrenceSection>`, que é o editor compartilhado: a sheet da linha usa o
// MESMO componente na variante `inline`. O que vive aqui é só a persistência — qual endpoint,
// que toast, e a preservação dos campos que esta seção não edita.
export function OrganizationRecurrenceSection({ calendar, canEdit }: Props) {
  const update = useUpdateOrganizationCalendar();

  async function save(rules: RecurringException[]) {
    // O PUT SUBSTITUI o calendário inteiro. Repassar turnos e exceções datadas não é redundância:
    // omiti-los apagaria a semana e os feriados ao salvar uma regra.
    await update.mutateAsync({
      weeklyShifts: calendar?.weeklyShifts ?? [],
      exceptions: calendar?.exceptions ?? [],
      recurringExceptions: rules,
    });
    toast.success("Regras recorrentes salvas.");
  }

  return (
    <RecurrenceSection
      value={calendar?.recurringExceptions ?? []}
      disabled={!canEdit || update.isPending}
      onChange={(rules) => void save(rules)}
    />
  );
}
